module.exports = __webpack_public_path__ + "static/media/NE.fff5fe24.png";